import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AuthUser } from '@parking/shared';

type AuthState = {
  accessToken: string | null;
  refreshToken: string | null;
  /** Epoch ms when access token should be considered expired */
  accessExpiresAt: number | null;
  user: AuthUser | null;
  tenantSlug: string;
  setSession: (payload: {
    accessToken: string;
    refreshToken: string;
    user: AuthUser;
    tenantSlug?: string;
    expiresIn?: number;
  }) => void;
  setTenantSlug: (slug: string) => void;
  clear: () => void;
  hasPermission: (code: string) => boolean;
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      accessToken: null,
      refreshToken: null,
      accessExpiresAt: null,
      user: null,
      tenantSlug: 'demo',
      setSession: ({ accessToken, refreshToken, user, tenantSlug, expiresIn }) =>
        set({
          accessToken,
          refreshToken,
          user,
          accessExpiresAt:
            typeof expiresIn === 'number'
              ? Date.now() + expiresIn * 1000
              : get().accessExpiresAt ?? Date.now() + 900_000,
          ...(tenantSlug ? { tenantSlug } : {}),
        }),
      setTenantSlug: (tenantSlug) => set({ tenantSlug }),
      clear: () =>
        set({
          accessToken: null,
          refreshToken: null,
          accessExpiresAt: null,
          user: null,
        }),
      hasPermission: (code) => Boolean(get().user?.permissions.includes(code)),
    }),
    { name: 'parking-auth' },
  ),
);
